export const ALWAYS = 'ALWAYS';
export const TEAM_MEMBERS = 'TEAM_MEMBERS';
export const OFFICE_HOURS = 'OFFICE_HOURS';